import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "../../globalComponents";
import { useAuth } from "../../context/auth.context";
import { useWhitelabel } from "../../context/whitelabel.context";

const AdminEntryChoice = () => {
    const navigate = useNavigate()
    const { isAdmin, SetAdminAccessMode } = useAuth()
    const { logoVertical } = useWhitelabel()

    useEffect(() => {
        if (!isAdmin) {
            navigate('/')
        }
    }, [isAdmin, navigate])

    const handleEnterSite = () => {
        SetAdminAccessMode('site')
        navigate('/')
    }

    const handleEnterPanel = () => {
        SetAdminAccessMode('panel')
        navigate('/admin')
    }

    if (!isAdmin) return null

    return (
        <div style={{
            minHeight: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
            background: 'linear-gradient(140deg, #080808 0%, #111111 50%, #1b1b1b 100%)'
        }}>
            <div style={{
                width: '100%',
                maxWidth: 520,
                borderRadius: 16,
                border: '1px solid #2b2b2b',
                backgroundColor: '#0d0d0d',
                boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                padding: 24,
                display: 'flex',
                flexDirection: 'column',
                gap: 18
            }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                        src={logoVertical}
                        alt="Logo"
                        style={{ width: '100%', height: '100%', maxWidth: 120, maxHeight: 120, objectFit: 'contain' }}
                    />
                </div>

                <h1 style={{ margin: 0, color: '#fff' }}>Acesso de Administrador</h1>
                <p style={{ margin: 0, color: '#d2d2d2' }}>
                    Seu usuario possui perfil de admin. Escolha para onde deseja entrar agora.
                </p>

                <PrimaryButton onClick={handleEnterSite} style={{ width: '100%' }}>
                    Entrar no Site
                </PrimaryButton>

                <SecondaryButton onClick={handleEnterPanel} style={{ width: '100%' }}>
                    Ir para Painel de Controle
                </SecondaryButton>
            </div>
        </div>
    )
}

export default AdminEntryChoice
